import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { isAuthenticated, isAuthEnabled, validateKeyAndStore, setToken } from '../helpers/auth'
import { PageInstanceTracker } from '../helpers/pageInstances'

export default function ProtectedRoute({ children }) {
	const location = useLocation()
	const [checking, setChecking] = useState(true)
	const [authed, setAuthed] = useState(false)

	useEffect(() => {
		if (!isAuthEnabled()) {
			setAuthed(true)
			setChecking(false)
			return
		}

		const params = new URLSearchParams(location.search)
		const token = params.get('token')
		const key = params.get('key')

		if (token) {
			// Pre-signed token from a shareable URL — store it and leave the URL intact
			setToken(token)
			setAuthed(true)
			setChecking(false)
		} else if (key) {
			validateKeyAndStore(key).then((ok) => {
				setAuthed(ok)
				setChecking(false)
				if (ok) {
					params.delete('key')
					const newSearch = params.toString()
					const newUrl = location.pathname + (newSearch ? `?${newSearch}` : '')
					window.history.replaceState({}, '', newUrl)
				}
			})
		} else {
			setAuthed(isAuthenticated())
			setChecking(false)
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	if (checking) return null

	if (!authed) {
		const redirect = encodeURIComponent(location.pathname + location.search)
		return <Navigate to={`/login?redirect=${redirect}`} replace />
	}

	// Only authenticated pages report themselves to the dashboard
	return (
		<>
			<PageInstanceTracker />
			{children}
		</>
	)
}
